import React from 'react';
import PropTypes from 'prop-types';

import {
    Heading,
    FormContainer,
    SubHeading,
    SmallText,
    SignUpLink,
    HoverLink,
    SignUpTermsAndConditionsWrapper,
} from '../style';
import { AuthenticationWrapper } from '../AuthenticationWrapper';
import { externalLinks, paths } from '../../../../Constants/paths';
import { Row } from '../../../Layouts';

export const SignUpWrapper = ({ title, subtitle, children }) => (
    <AuthenticationWrapper>
        <FormContainer>
            <Heading marginBottom={'12px'}>{title}</Heading>
            <SubHeading marginBottom={'24px'}>{subtitle}</SubHeading>

            {children}

            <SignUpTermsAndConditionsWrapper>
                <Row>
                    <SmallText marginRight={'4px'}>By signing up to Tona you agree to our</SmallText>
                    <HoverLink to={{ pathname: externalLinks.TERMS_AND_CONDITIONS }} target={'_blank'}>
                        Terms of Service
                    </HoverLink>
                </Row>
                <Row marginTop={'8px'}>
                    <SmallText marginRight={'4px'}>View our</SmallText>
                    <HoverLink to={{ pathname: externalLinks.PRIVACY_POLICY }} target={'_blank'}>
                        privacy policy.
                    </HoverLink>
                </Row>
            </SignUpTermsAndConditionsWrapper>

            <Row>
                <SubHeading marginRight={'8px'}>Already have an account?</SubHeading>
                <SignUpLink to={paths.ENTRY_PAGE}>Sign in</SignUpLink>
            </Row>
        </FormContainer>
    </AuthenticationWrapper>
);

SignUpWrapper.defaultProps = {
    title: '',
    subtitle: '',
};

SignUpWrapper.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignUp/SignUpWrapper.js